<div class="calendar-container">

  <div class="calendar-container-content" [ngClass]="{'active': showSearch}">

    <hub-button class=" f-right "
                [title]="'workshop.calendar.schedule' | translate"
                [text]="'workshop.calendar.schedule' | translate"
                [style]="'secondary'"
                [size]="'md'" [icon]="'memo-pencil'" (buttonClick)="scheduleService()">
    </hub-button>

    <hub-button class=" f-right " *ngIf="(this.useNewScheduleScreen || this.partnerData.UseNewJobCard) && this.partnerData.PartnerType === 1"
                [title]="'workshop.calendar.scan' | translate"
                [text]="'workshop.calendar.scan' | translate"
                [style]="'secondary'"
                [size]="'md'" [icon]="'scan'" (buttonClick)="scheduleServiceUsingBarcode()">
    </hub-button>

    <hub-button class=" f-right "
                [title]="'workshop.calendar.leave' | translate"
                [text]="'workshop.calendar.leave' | translate"
                [style]="'primary'"
                [iconColor]="'#ffffff'"
                [size]="'md'" [icon]="'calendar-xmark-alt'" (buttonClick)="toggleAdd()">
    </hub-button>


    <!--<button type="button" class="fc-resourceTimeGridDay-button fc-button fc-button-primary f-right accent"
            (click)="scheduleService()">
      {{ 'bikeshop.modal.shedule_service.schedule_service' | translate }}
    </button>
    <button type="button" class="fc-resourceTimeGridDay-button fc-button fc-button-primary f-right"
            (click)="toggleAdd()">
      {{ 'bikeshop.calendar.add_new' | translate }}
    </button>-->
    <div class="option-box" [ngClass]="{ hide: !addNew }">
      <div class="option" (click)="addLeave()">
        {{ 'bikeshop.calendar.add_leave' | translate }}
      </div>
      <div class="option" (click)="addClosedDate()">
        {{ 'bikeshop.calendar.add_closed' | translate }}
      </div>
    </div>
    <div class="content" [ngClass]="{'updating-calendar': loading}">
      <div joyrideStep="calendarStepOne" stepPosition="center" [stepContent]="calendarDemo" (done)="tourDone()">
        <full-calendar #calendar [schedulerLicenseKey]="'0984855613-fcs-1539348025'" ignoreTimezone="false"
                       [nowIndicator]="true" [now]="getNowDate()" timeZone="UTC" defaultView="Week"
                       [locales]="[ 'enLocale', 'esLocale' ]"
                       [header]="{
                                                            right: 'prev, next, today',
                                                            center: 'title',
                                                            left: headerView
                                                          }"
                       [views]="calendarViews"
                       [buttonText]="calendarButtonText" [navLinks]="true" [rerenderDelay]="100"
                       [showNonCurrentDates]="true"
                       [plugins]="calendarPlugins" [weekends]="calendarWeekends" [resources]="technicians"
                       resourceOrder="sortOrder, id" [minTime]="minTime"
                       [maxTime]="maxTime" [eventLimit]="true" [allDaySlot]="false" [selectable]="true"
                       [editable]="true"
                       [contentHeight]="contentHeight" (eventRender)="renderEvent($event)"
                       (dateClick)="dateClicked($event)" (resourceRender)="renderResource($event)"
                       (eventClick)="scheduleClicked($event)" (eventDrop)="scheduleMoved($event)"
                       (eventResize)="scheduleDurationChanged($event)" [firstDay]="1"
                       resourceLabelText="{{ 'bikeshop.service_types.technicians' | translate }}"
                       (eventMouseEnter)="eventMouseEnter($event)"
                       (eventMouseLeave)="eventMouseLeave($event)"
                       (datesRender)="datesRender($event)"
                       (navLinkDayClick)="goToDate($event)">
        </full-calendar>
      </div>
      <ng-template #calendarDemo>
        <div>
          <div>
            {{ 'bikeshop.tour.calendar.step_one' | translate }}
          </div>
          <div class="margin-top-16">
            <!-- <youtube-player videoId="hbvPCdhU5kw" width="100%" startSeconds="20"></youtube-player> -->
            <img src="../../../../../../assets/Calendar.gif" style="width: 100%;height: 400px;" />
          </div>
        </div>
      </ng-template>
    </div>
    <div *ngIf="techniciansRaw && techniciansRaw.length > 0 && calendarApi.view.type === 'Week'">

      <div joyrideStep="calendarStepThree" stepPosition="top"
           text="{{ 'bikeshop.tour.calendar.step_three' | translate }}" (done)="tourDone()">
        <app-availability [techniciansHidden]="techniciansHidden" [technicians]="techniciansRaw"
                          [eventDates]="getEventDates()"></app-availability>
      </div>
    </div>

  </div>


  <div class="side-bar-right" [ngClass]="{'close-bar': showSearch}">
    <div class="search-icon" (click)="handleSearchClick()">
      <div joyrideStep="calendarStepTwo" text="{{ 'bikeshop.tour.calendar.step_two' | translate }}"
           (done)="tourDone()">
        <daz-icon [name]="'search'" [size]="'26px'"
                  [color]="'#060931'"></daz-icon>
      </div>
      <div class="search-text"></div>
    </div>
    <div>

      <div class="status-legend">
        <!--<div *ngFor="let status of statusList">
          <div style="display: -webkit-box; cursor:pointer;" (click)="filterStatuses(status.id)"
               *ngIf="status.key !== 31 || (status.key === 31 && partnerData.ShowINeedHelp)">
            <div class="legend" [ngClass]="status.styleClass"></div>
            <div class="widget-title">{{status.label}}</div>
          </div>
        </div>-->

        <div style="display: -webkit-box; cursor:pointer;">
          <div class="widget-title" (click)="resetFilteredStatuses()"><i class="pi pi-refresh"></i></div>
        </div>

        <div *ngFor="let status of statusList" (click)="filterStatuses(status.id)" style="cursor:pointer;">
          <!--<div *ngIf="statusesHidden.indexOf(status.id) != -1" style="display:flex; opacity: 0.25">
            <avatar size="20" name="{{status.label}}"></avatar>
          </div>
          <div *ngIf="statusesHidden.indexOf(status.id) == -1" style="display:flex; opacity: 1">
            <avatar size="20" name="{{status.label}}"></avatar>
          </div>-->
          <div *ngIf="statusesHidden.indexOf(status.id) != -1" style="opacity: 0.5;">
            <div style="display: -webkit-box; cursor:pointer;"
                 *ngIf="status.key !== 31 || (status.key === 31 && partnerData.ShowINeedHelp)">
              <div class="legend" [ngClass]="status.styleClass"></div>
              <div class="widget-title">{{status.label}}</div>
            </div>
          </div>
          <div *ngIf="statusesHidden.indexOf(status.id) == -1" style="opacity: 1;">
            <div style="display: -webkit-box; cursor:pointer;"
                 *ngIf="status.key !== 31 || (status.key === 31 && partnerData.ShowINeedHelp)">
              <div class="legend" [ngClass]="status.styleClass"></div>
              <div class="widget-title">{{status.label}}</div>
            </div>
          </div>
        </div>

      </div>


      <div class="legend-info">
        <span (mouseover)="showBorderinfo = true" (mouseout)="showBorderinfo = false">
          <daz-icon [name]="'border'"
                    [size]="'26px'"
                    [color]="'#060931'"></daz-icon>
        </span>
        <span *ngIf="showBorderinfo" class="border-tool-tip">Linked job</span>
        <span (mouseover)="showPaidinfo = true" (mouseout)="showPaidinfo = false">
          <daz-icon [name]="'thickborder'"
                    [size]="'26px'"
                    [color]="'#060931'"></daz-icon>
        </span>
        <span *ngIf="showPaidinfo" class="border-tool-tip">Job is paid</span>
        <span (mouseover)="showNotHereinfo = true" (mouseout)="showNotHereinfo = false">
          <daz-icon [name]="'striped'"
                    [size]="'26px'"
                    [color]="'#060931'"></daz-icon>
        </span>
        <span *ngIf="showNotHereinfo" class="border-tool-tip">Item not here</span>
      </div>


      <!--<div class="technician-legend" *ngIf="partnerData.ShowTechnicianLegendCalendar">-->
      <div class="technician-legend">
        <div style="display: -webkit-box; cursor: pointer; padding-bottom: 8px;">
          <div (click)="resetFilteredTechnicians()">
            <i class="pi pi-refresh"
               style="font-family: 'primeicons' !important; font-size: 1.5em !important;"></i>
          </div>
        </div>
        <div *ngFor="let technician of techniciansRaw" (click)="filterTechnicians(technician.id)"
             style="cursor:pointer;">
          <div *ngIf="techniciansHidden.indexOf(technician.id) != -1" style="display:flex; opacity: 0.25">
            <avatar size="20" name="{{technician.Name}}"></avatar>
          </div>
          <div *ngIf="techniciansHidden.indexOf(technician.id) == -1" style="display:flex; opacity: 1">
            <avatar size="20" name="{{technician.Name}}"></avatar>
          </div>
          <div *ngIf="techniciansHidden.indexOf(technician.id) != -1"
               style="opacity: 0.5;">{{technician.Name}}</div>
          <div *ngIf="techniciansHidden.indexOf(technician.id) == -1"
               style="opacity: 1;">{{technician.Name}}</div>
        </div>
      </div>


      <div style="font-size: 11px; margin-top: 32px;margin-left: -6px;display:flex; align-items: center;column-gap: 4px;flex-wrap: nowrap;" *ngIf="!partnerData.UseNewJobCard">
        <p-checkbox [(ngModel)]="useNewScheduleScreen" [binary]="true"></p-checkbox> {{'bikeshop.calendar.try_new_jobcard' | translate}}
      </div>

    </div>
  </div>
  <div class="side-bar-right-extra" [ngClass]="{'active': showSearch}">
    <div class="title"></div>
    <button type="button" class="close-search close" aria-label="Close" (click)="closeSearch()">
      <span class="hubtiger-close"></span>
    </button>
    <div class="margin-top-16">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon" (click)="search(); highlight();"><i class="fa fa-search"></i></span>
        <input type="text" [(ngModel)]="searchRequest" pInputText
               placeholder="{{ 'general.search' | translate}}"
               (keyup)="changeSearch()"
               (keydown.enter)="search();  highlight();" id="search-text-box" #searchtextbox>
      </div>
      <div class="margin-top-8" *ngIf="connectedStores && connectedStores.length > 1">
        <p-checkbox [(ngModel)]="searchAllStores" [binary]="true" inputId="binary" (ngModelChange)="updateSearch();  highlight();"></p-checkbox>
        <small style="margin-left: 8px;font-style: italic;">{{'general.search_all_stores' | translate}}</small>
      </div>
      <div *ngIf="searchResults.length === 0 && searchRequest.trim() === ''">
        <div class="search-info" innerHTML="{{'general.searchoptions' | translate}}"></div>
      </div>
      <div *ngIf="searchRequest.trim() !== ''" style="margin-top: 10px;">
        <div class="flex-wrap gap-3">

          <div class="flex align-items-center">
            <p-radioButton name="jobcardNo" value="jobcardNo" [(ngModel)]="searchFor" inputId="jobcardNo" />
            <label for="jobcardNo" class="search-info">{{ 'general.jobcard_no' | translate}}</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="email" value="email" [(ngModel)]="searchFor" inputId="email" />
            <label for="email" class="search-info">{{ 'general.email' | translate}}</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="phone" value="phone" [(ngModel)]="searchFor" inputId="phone" />
            <label for="phone" class="search-info">{{ 'general.phone' | translate}}</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="name" value="name" [(ngModel)]="searchFor" inputId="name" />
            <label for="name" class="search-info">{{ 'general.name' | translate}}</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="item" value="item" [(ngModel)]="searchFor" inputId="item" />
            <label for="item" class="search-info">{{ 'general.bike' | translate}}</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="serialNo" value="serialNo" [(ngModel)]="searchFor" inputId="serialNo" />
            <label for="serialNo" class="search-info">{{ 'bikeshop.modal.shared.bike.serial_no' | translate}}</label>
          </div>
          <div class="flex align-items-center">
            <p-radioButton name="bay" value="bay" [(ngModel)]="searchFor" inputId="bay" />
            <label for="bay" class="search-info">{{ 'bikeshop.modal.shared.bike.bay_tag_number' | translate}}</label>
          </div>

        </div>
      </div>
    </div>
    <div *ngIf="searching" class="search-loader">
      <div class="loading">
        <div class="loader"></div>
      </div>
    </div>

    <div *ngIf="!searching" class="results-container" id="results-container" (scroll)="onResultsScroll($event)">
      <div class="result" [ngClass]="{'other-shop': partnerID !== searchResult.PartnerID}"
           *ngFor="let searchResult of searchResults"
           (click)="partnerID === searchResult.PartnerID ? openJobCard(searchResult.ID) : null">
        <div style="display: flex">
          <div style="max-width:75%; min-width:75%; font-size:16px;" class=""><strong>{{searchResult.CyclistDescription}}</strong></div>
          <div style="max-width:25%; min-width:25%;" class="jobcard">{{searchResult.JobCardNo}}</div>
        </div>
        <div *ngIf="searchResult.PhoneNumber && searchResult.PhoneNumber.length > 0">{{searchResult.PhoneNumber}}</div>
        <div *ngIf="searchResult.Email && searchResult.Email.length > 0">{{searchResult.Email}}</div>
        <div>{{searchResult.BikeDescription}}</div>
        <div *ngIf="searchResult.BikeBay">
          <span>
            {{ "bikeshop.modal.shared.bike.bay_tag_number" | translate }}
            :
          </span> {{searchResult.BikeBay}}
        </div>
        <div *ngIf="searchResult.SerialNo">
          <span>
            {{ "bikeshop.modal.shared.bike.serial_no" | translate }}
            :
          </span> {{searchResult.SerialNo}}
        </div>
        <div class="date"><strong>{{searchResult.DateCheckedIn | date: displayDateTimeFormat : 'UTC' }}</strong></div>
        <div class="date red"
             *ngIf="searchResult.PartnerID != partnerID">{{searchResult.PartnerDescription}}</div>

        <div *ngFor="let status of statusList">
          <div *ngIf="status.label === searchResult.StatusDescription">
            <div class="" style="border-radius: 10px; padding-left: 10px;padding-right: 10px;max-width: fit-content;margin-top: 5px;" [ngClass]="status.styleClass">
              {{searchResult.StatusDescription}}
            </div>
          </div>
        </div>
      </div>

      <div class="empty-state-content" *ngIf="showNoResults">
        <div>
          <span class="fa fa-search fa-3x"></span>
        </div>
        <div>
          <div class="empty-state-text">
            <div class="empty-state-header-text">{{ "bikeshop.cyclist.no_customers_found" | translate }} {{searchRequest.trim()}} </div>
            <div class="empty-state-header-text">{{ "bikeshop.cyclist.search_something_else" | translate }}</div>
          </div>
        </div>
      </div>
    </div>


  </div>
</div>


<div id="iso-popup" class="iso-popup" style="display: none;">
  <!-- Content will be dynamically inserted here -->
</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-toast position="top-center" styleClass="hubtiger-toast" key="link-copied"></p-toast>
<p-confirmDialog key="confirm_move"></p-confirmDialog>

